import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PcsFilterCriteriaforHighlight } from 'src/app/common/models/PendingIntegeration';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { HttpcallService } from 'src/app/common/services/httpcall.service';
import { LoginService } from 'src/app/common/services/Login.service';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import scrollIntoView from 'scroll-into-view-if-needed';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sec-page-viewer',
  templateUrl: './sec-page-viewer.component.html',
  styleUrls: ['./sec-page-viewer.component.css']
})
export class SecPageViewerComponent implements OnInit, AfterViewChecked {


  private destroy$: Subject<void> = new Subject<void>();
  title: string = "";
  body;
  publicationId
  pageId;
  paragraphs: string[];
  TopicTitle: string[];
  topicheader: string;
  paragraphContent = [];
  @Input() pageurl;
  pageHeading;
  printqueueAdded: boolean = false;
  paragraphIdsList: any[] = [];
  printqueueAddedList: any[] = [];
  paraArticleId: string = "";
  addedparagraphList = [];
  event$
  archivePage: boolean = false;
  TopicBody: string[];
  topicBodyContent: any = [];
  paragraph: string[];
  topicheader2: string;

  FiscalDate: any;
  PeriodType: string;
  fillingStatus: string;
  periodTypeLabel: any;
  sectionHeader: any;
  fillingStatus_Label: any;
  showingContent_Label: any;
  search: PcsFilterCriteriaforHighlight = new PcsFilterCriteriaforHighlight();
  ShowSecContent: boolean = true;
  hasSecContent: any;
  secContent: any;
  PendingContentMergeList: any[];

  @Input() ContentPath: any;
  @Input() UserInfo: any;
  @Input() crumbData: any;
  @Input() hasActualContent: any;
  @Input() s3ImageBasePath: string = "";
  @Input() PendingContentMerge: any;
  @Input() PendingContentPage: boolean = false;
  @Input() crossReferencedContentID: string;
  @Input() crossreferenceparagraphNumber: string;
  @Input() crossreferencestandardNumber: string;
  @Input() crossreferencestandardType: string;
  @Input() menuListItems: any;
  @Input() paragraphTitleContentSec: any;
  @Input() topicBodyContentSec: any;
  @Input() pageHeadingSec: string = "";
  @Input() outcomeSec: boolean = false;
  @Input() topic_subtopicNum: string = "";
  @Input() annotationCount: any = {};
  @Input() bookmarkCount: any = {};

  constructor(private router: Router, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private loginService: LoginService,
    private graphQLService: GraphqlService, private sanitizer: DomSanitizer, private openLink: OpenLinkById, private browserTitle: Title) {
  }
  breadcrumbPath: string = "";
  pageNumsForCount: string = "";

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.paragraphIdsList = [];
    this.printqueueAddedList = [];
    this.commonDataService.showLoader.next(false);

    this.paragraphContent = [];
    this.paragraphIdsList = [];
    //this.loadPendingDataForContentPage();

    if (this.crumbData != null) {
      this.pageNumsForCount = ""
      this.breadcrumbPath = this.crumbData[0] + "~";
      for (let i = 1; i < this.crumbData.length; i++) {
        if (i != this.crumbData.length - 1) {
          if (!this.crumbData[i].split(" ")[0].includes("X")) {
            this.pageNumsForCount += this.crumbData[i].split(" ")[0] + "-";
            this.breadcrumbPath += this.crumbData[i] + "~";
          }
        }
        else {
          if (!this.crumbData[i].split(" ")[0].startsWith('S')) {
            this.pageNumsForCount += "S" + this.crumbData[i].split(" ")[0];
            this.breadcrumbPath += "S" + this.crumbData[i];
          } else {
            this.pageNumsForCount += this.crumbData[i].split(" ")[0];
            this.breadcrumbPath += this.crumbData[i];
          }
        }
      }
    }
    this.commonDataService.printqueueCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        var _id = data.articleId;
        let section = data.section;
        var paragraphId = data.paragraphId;
        let isSECPara = document.getElementById('SecContentStarted')?.innerHTML?.toLowerCase()?.includes(paragraphId?.trim()?.toLowerCase());
        let isGlossaryPara = !(/\d/.test(paragraphId));

        if (isSECPara) {
          isSECPara = true;
        }
        else {
          isSECPara = false;
        }
        if (data.toggleValue.toString() == 'true') {
          this.printqueueAdded = true;
          //document.getElementById(_id).style.display = "";
          /*if (this.paragraphIdsList == null) {*/
          //this.paragraphIdsList = [];
          //this.printqueueAddedList = [];
          /*}*/
          this.paragraphIdsList.push({ id: paragraphId, isSecParagraph: isSECPara, isGlossaryParagraph: isGlossaryPara });
          this.printqueueAddedList.push({ guid: data.articleId, topicNumber: data.topic, subTopicNumber: data.subtopic, sectionNumber: section });
          let body = {
            ParagraphIdsList: this.paragraphIdsList,
            printQueueAddedList: this.printqueueAddedList
          };
          localStorage.setItem("SetPrintQueueSession", JSON.stringify(body));
        }
        else {
          this.printqueueAdded = false;
          //document.getElementById(_id).style.display = "none";
          this.remove(this.paragraphIdsList, paragraphId);
          //this.remove(this.printqueueAddedList, data.articleId);
          this.printqueueAddedList = this.printqueueAddedList.filter(item => item.guid != data.articleId);
          const _body = {
            ParagraphIdsList: this.paragraphIdsList,
            printQueueAddedList: this.printqueueAddedList
          };
          localStorage.setItem("SetPrintQueueSession", JSON.stringify(_body));
        }
      }
    })
    this.publicationId = this.router.url.split("/")[1];
    this.pageId = this.ContentPath.split("/")[1];
    this.pageName = this.crumbData[this.crumbData.length - 1];
    this.MapLoginData(this.UserInfo);

    //this.PendingContentPage = false;
    //this.loadPendingDataForContentPage();

    this.commonDataService.annotationWithinContent.next(null);
    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {

      if (data == "toggleOff") {
        this.paragraphIdsList = [];
        this.printqueueAddedList = [];
      }
    })
    this.commonDataService.printContentHideShow.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "Hide") {
        setTimeout(() => {
          var hide = document.getElementsByClassName("print-content-hide")
          Array.prototype.forEach.call(hide, function (obj) {
            obj.style.display = ""
          });
        }, 500)

        this.commonDataService.printContentHideShow.next(null);
      }
    });
    this.commonDataService.showLoader.next(false);
  }
  isStarting: boolean = true;
  //ngAfterViewCheckedCounter: number = 0;
  ngAfterViewChecked(): void {
    let para = sessionStorage.getItem("paragraphNum");
    if (!(para === "undefined" || para === null)) {
      localStorage.removeItem("SecClicked");
      if (localStorage.getItem('backButtonClicked') === 'false') {
        if (this.isStarting) {
          if (!(para === "undefined" || para === null)) {
            let paraSplit = para.split("-");
            let para2 = "";
            if (paraSplit.length == 4) {
              para2 = paraSplit[1] + "-" + paraSplit[0] + "-" + paraSplit[2] + "-" + paraSplit[3];
            }
            if (document.getElementById(para) != null) {

              //if (this.ngAfterViewCheckedCounter != 10) {
              //  this.ngAfterViewCheckedCounter += 1;
              const node = document.getElementById(para);

              setTimeout(() => {
                scrollIntoView(node, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
                }
              }, 2000);
              //}

              // let node = document.getElementById(para);
              // scrollIntoViewIfNeeded(node, {
              //   block: 'start',
              //   inline: 'start',
              //   boundary: document.getElementsByTagName('app-main-content')[0]
              // })

              //this.destinationPara = document.getElementById(para).innerText;
              //if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
              //  this.saveHistoryWithParagraph();
              //}
              //sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
            }

            else if (document.getElementById(para2) != null) {
              para = para2;
              //if (this.ngAfterViewCheckedCounter != 10) {
              //  this.ngAfterViewCheckedCounter += 1;
              const node = document.getElementById(para2);

              setTimeout(() => {
                scrollIntoView(node, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para2);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
                }
              }, 2000);
              //}

              // let node = document.getElementById(para);
              // scrollIntoViewIfNeeded(node, {
              //   block: 'start',
              //   inline: 'start',
              //   boundary: document.getElementsByTagName('app-main-content')[0]
              // })

              //this.destinationPara = document.getElementById(para2).innerText;
              //if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
              //  this.saveHistoryWithParagraph();
              //}
              //sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
            }
            else {
              let paraCopy = para;
              let para0 = false;
              let para1 = false;
              for (let i = 0; i < this.crumbData.length; i++) {
                if (this.crumbData[i].includes(paraCopy.split('-')[0])) {
                  para0 = true;
                }
                if (this.crumbData[i].includes(paraCopy.split('-')[1])) {
                  para1 = true;
                }
              }

              if (para0 && para1) {
                let newParaId = para.split("-")[1] + "-" + para.split('-')[0] + "-" + para.split('-')[2] + "-" + para.split('-')[3];
                if (document.getElementById(newParaId) != null) {

                  //if (this.ngAfterViewCheckedCounter != 10) {
                  //  this.ngAfterViewCheckedCounter += 1;
                  const node = document.getElementById(newParaId);

                  setTimeout(() => {
                    scrollIntoView(node, {
                      scrollMode: 'always',
                      block: 'start',
                      inline: 'start',
                      boundary: document.getElementsByTagName('app-main-content')[0]
                    })
                    const element = document.getElementById(newParaId);
                    const rect = element.getBoundingClientRect();
                    const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                    const viewPortHeight = window.innerHeight;
                    const top1Percent = viewPortHeight * 0.01;
                    const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                    const maxScrollTop = documentHeight - viewPortHeight;
                    if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
                      sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
                    }
                  }, 2000);
                  //}

                  // let node = document.getElementById(para);
                  // scrollIntoViewIfNeeded(node, {
                  //   block: 'start',
                  //   inline: 'start',
                  //   boundary: document.getElementsByTagName('app-main-content')[0]
                  // })

                  //this.destinationPara = document.getElementById(para).innerText;
                  //if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
                  //  this.saveHistoryWithParagraph();
                  //}
                  //sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
                }
              }
            }
          }
        }
      }
      else {
        if (this.isStarting) {
          if (!(para === "undefined" || para === null)) {
            let paraSplit = para.split("-");
            let para2 = "";
            if (paraSplit.length == 4) {
              para2 = paraSplit[1] + "-" + paraSplit[0] + "-" + paraSplit[2] + "-" + paraSplit[3];
            }
            if (document.getElementById(para) != null) {
              // setTimeout(function () { 
              //   // document.getElementById(para).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); 
              //   var paraId = document.getElementById(para);
              //   scrollIntoViewIfNeeded(paraId, {
              //     block: 'start',
              //     inline: 'start',
              //     boundary: document.getElementsByTagName('app-main-content')[0]
              //   })
              //   sessionStorage.removeItem("paragraphNum"); this.isStarting = false; }, 100);

              //if (this.ngAfterViewCheckedCounter != 10) {
              //  this.ngAfterViewCheckedCounter += 1;
              const node = document.getElementById(para);

              setTimeout(() => {
                scrollIntoView(node, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum"); this.isStarting = false; localStorage.removeItem("SecClicked");
                }
              }, 2000);
              //}
            }
            else if (document.getElementById(para2) != null) {
              //console.log("SEC Inside GetElementById for Para2 " + para2)
              // setTimeout(function () { 
              //   // document.getElementById(para).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); 
              //   var paraId = document.getElementById(para);
              //   scrollIntoViewIfNeeded(paraId, {
              //     block: 'start',
              //     inline: 'start',
              //     boundary: document.getElementsByTagName('app-main-content')[0]
              //   })
              //   sessionStorage.removeItem("paragraphNum"); this.isStarting = false; }, 100);
              para = para2;
              //if (this.ngAfterViewCheckedCounter != 10) {
              //  this.ngAfterViewCheckedCounter += 1;
              const node = document.getElementById(para2);

              setTimeout(() => {
                scrollIntoView(node, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para2);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum"); this.isStarting = false; localStorage.removeItem("SecClicked");
                }
              }, 2000);
              //}
              //sessionStorage.removeItem("paragraphNum"); this.isStarting = false; localStorage.removeItem("SecClicked");
            }
          }
        }
      }
    }
    else {
      let secPageClicked = localStorage.getItem("SecClicked");
      if ((!(secPageClicked === "undefined" || secPageClicked === null)) && (localStorage.getItem('backButtonClicked') != 'true')) {
        if (document.getElementById(secPageClicked) != null) {
          // document.getElementById(secPageClicked).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          var secID = document.getElementById(secPageClicked);
          // scrollIntoViewIfNeeded(secID, {
          //   block: 'start',
          //   inline: 'start',
          //   boundary: document.getElementsByTagName('app-main-content')[0]
          // })
          // setTimeout(function () { localStorage.removeItem("SecClicked"); }, 1000);
          //if (this.ngAfterViewCheckedCounter != 10) {
          //  this.ngAfterViewCheckedCounter += 1;

          setTimeout(() => {
            scrollIntoView(secID, {
              scrollMode: 'always',
              block: 'start',
              inline: 'start',
              boundary: document.getElementsByTagName('app-main-content')[0]
            })

            const element = document.getElementById(secPageClicked);
            const rect = element.getBoundingClientRect();
            const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
            const viewPortHeight = window.innerHeight;
            const top1Percent = viewPortHeight * 0.01;
            const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
            const maxScrollTop = documentHeight - viewPortHeight;
            if (rect.top < top1Percent || scrollTop + 200 >= maxScrollTop) {
              localStorage.removeItem("SecClicked");
            }
          }, 2000);
          //}
        }
      }
    }
  }
  //loadPendingDataForContentPage() {
  //  this.graphQLService.GetPCSIntegratedFlag().subscribe(data => {
  //    if (data) {
  //      this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId).subscribe(res => {
  //        if (res != null) {
  //          this.FiscalDate = "Fiscal year beginning " + formatDate(res.date, 'MM/dd/yyyy', 'en-US');
  //          this.fillingStatus = res.periodtype;
  //          this.PeriodType = res.filingStatus;
  //          this.getPCSLabels();

  //          this.PendingContentMergeList = res.pcsIntegrationData;
  //          this.PendingContentPage = true;
  //        }
  //        else {
  //          this.PendingContentPage = false;
  //        }

  //      })
  //    }
  //  })

  //}
  EditPCS() {
    let PCS = { fillingStatus: this.fillingStatus, periodType: this.PeriodType, Date: this.FiscalDate.split("Fiscal year beginning ")[1] };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.commonDataService.EditFromContentPage.next(true);
    this.router.navigateByUrl("/pendingcontentsystem");
  }
  ResetPCS() {
    this.graphQLService.SetPCSIntegratedFlag(false).subscribe(data => {
      this.PendingContentPage = false;
    })

  }
  getPCSLabels() {
    this.graphQLService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.sectionHeader = labels.filter(x => x.key == "pc_contentheader").map(y => y.value);
        this.periodTypeLabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.fillingStatus_Label = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.showingContent_Label = labels.filter(x => x.key == "pc_Showingcontent_label").map(y => y.value);
      }
    });
  }
  remove(arr, what) {
    arr.sort().forEach(function (value, index) {
      if (value.id === what) {
        arr.splice(index, 1);
      }
    });
  }

  //bookmarkCount: any;
  //annotationCount: any;
  //apiResponse: any;
  //getPageContent(publicationId: string, pageId: string, pageName: string) {
  //  var pageHeader = { "publicationId": publicationId, "pageId": pageId, "pageName": pageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMerge };
  //  var paragraphActionInputBody = { NavigationPath: this.pageNumsForCount, UserId: this.emailId, Application: "" };
  //  if (this.userRole != "Basic") {
  //    forkJoin([
  //      this.httpCallService.getBookmarkCount(paragraphActionInputBody),
  //      this.httpCallService.getAnnotationCount(paragraphActionInputBody), this.graphQLService.getPageData(pageHeader)
  //    ]).subscribe(([respBookmarkCount, respAnnotationCount, result]) => {
  //      this.bookmarkCount = respBookmarkCount;
  //      this.annotationCount = respAnnotationCount;
  //      this.topicBodyContent = [];
  //      this.apiResponse = result;
  //      //const { topicTitle, topicBody } = this.apiResponse.containerItems[0].rawContent.data.component.fields;
  //      //this.TopicTitle=this.apiResponse.topicTitle;
  //      this.title = this.apiResponse.contentPageTitle;
  //      this.apiResponse.contentPageInfo.forEach(info => {
  //        let obj = {
  //          PageInfoPosition: info.infoPosition,
  //          contentPageTitle: info.contentPageTitle,
  //          contentPageBody: this.sanitizer.bypassSecurityTrustHtml(info.contentPageBody)
  //        }
  //        this.topicBodyContent.push(obj);
  //      });
  //      //this.body = topicBody.values[0];
  //      this.getParagraphs(this.apiResponse);
  //      this.getPrintSession();
  //    }, err => {
  //      console.log(err);
  //    });
  //  }
  //  else {
  //    this.graphQLService.getPageData(pageHeader).subscribe(result => {
  //      this.topicBodyContent = [];
  //      this.apiResponse = result;
  //      //const { topicTitle, topicBody } = this.apiResponse.containerItems[0].rawContent.data.component.fields;
  //      //this.TopicTitle=this.apiResponse.topicTitle;
  //      this.title = this.apiResponse.contentPageTitle;
  //      this.apiResponse.contentPageInfo.forEach(info => {
  //        let obj = {
  //          PageInfoPosition: info.infoPosition,
  //          contentPageTitle: info.contentPageTitle,
  //          contentPageBody: this.sanitizer.bypassSecurityTrustHtml(info.contentPageBody)
  //        }
  //        this.topicBodyContent.push(obj);
  //      });
  //      //this.body = topicBody.values[0];
  //      this.getParagraphs(this.apiResponse);
  //      this.getPrintSession();
  //    }, err => {
  //      console.log(err);
  //    });
  //  }
  //}  

  //paraGroups: any[] = [];
  pageName: string = "";
  //paragraphTitleContent: any[] = [];
  //pgroups = [];
  //pgroup;
  //pgroupName: string = "";
  //paragraphArrayIds: string[] = [];
  //paragraphNum: string[] = [];
  //annotationCountDictionary: string[] = [];
  //bookmarkCountDictionary: string[] = [];
  //outcome: boolean = false;
  //getParagraphs(response) {
  //  this.paragraphContent = [];
  //  this.paragraphTitleContent = [];
  //  if (this.userRole != "Basic" && (!this.title.includes("XBRL Elements"))) {
  //    var printTemp: boolean = false;
  //      for (let l = 0; l < response.paraGroups.length; l++) {
  //        this.paragraphContent = [];
  //        for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
  //          for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
  //          if (this.addedparagraphList) {
  //            this.addedparagraphList.some(obj => obj.value === response.paraGroups[l].pgroups[k].paragraphArrayIds[i]) ? printTemp = true : printTemp = false;
  //          }
  //          if (i == 0) {
  //            let temp = {
  //              paragroup: response.paraGroups[l].pgroups[k].pgroupName,
  //              id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
  //              paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
  //              paraAnnotationCount: this.annotationCount[response.paraGroups[l].pgroups[k].paragraphArrayIds[i]],
  //              paraBookmarkCount: this.bookmarkCount[response.paraGroups[l].pgroups[k].paragraphArrayIds[i]],
  //              paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
  //              paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
  //              paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
  //              paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
  //              paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
  //              paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
  //              PrintQueueAdded: printTemp,
  //              actionLabel: this.menuListItems
  //            }
  //            this.paragraphContent.push(temp);
  //          }
  //          else {
  //            let temp = {
  //              paragroup: "",
  //              id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
  //              paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
  //              paraAnnotationCount: this.annotationCount[response.paraGroups[l].pgroups[k].paragraphArrayIds[i]],
  //              paraBookmarkCount: this.bookmarkCount[response.paraGroups[l].pgroups[k].paragraphArrayIds[i]],
  //              paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
  //              paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
  //              paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
  //              paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
  //              paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
  //              paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
  //              PrintQueueAdded: printTemp,
  //              actionLabel: this.menuListItems
  //            }
  //            this.paragraphContent.push(temp);
  //          }
  //          }
  //        }
  //        this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: this.paragraphContent });
  //      }
  //      this.outcome = true;
  //    this.commonDataService.showLoader.next(false);
  //  }
  //  else {
  //    for (let l = 0; l < response.paraGroups.length; l++) {
  //      this.paragraphContent = [];
  //      for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
  //        for (var i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
  //          if (i == 0) {
  //            let temp = {
  //              paragroup: response.paraGroups[l].pgroups[k].pgroupName,
  //              id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
  //              paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
  //              paraAnnotationCount: 0,
  //              paraBookmarkCount: 0,
  //              paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
  //              paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
  //              paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
  //              paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
  //              paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
  //              paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
  //              PrintQueueAdded: false,
  //              actionLabel: []
  //            }
  //            this.paragraphContent.push(temp);
  //          }
  //          else {
  //            let temp = {
  //              paragroup: "",
  //              id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
  //              paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
  //              paraAnnotationCount: 0,
  //              paraBookmarkCount: 0,
  //              paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
  //              paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
  //              paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
  //              paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
  //              paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
  //              paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
  //              PrintQueueAdded: false,
  //              actionLabel: []
  //            }
  //            this.paragraphContent.push(temp);
  //          }
  //        }
  //      }
  //      this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: this.paragraphContent });
  //    }
  //    this.outcome = true;
  //    this.commonDataService.showLoader.next(false);
  //  }
  //  this.pageHeading = this.title;
  //  if(!this.hasActualContent){
  //    this.browserTitle.setTitle(this.pageHeading);
  //  }
  //}
  emailId: string = "";
  userRole: string = "";
  MapLoginData(loginData) {
    this.commonDataService.emailId.next(loginData.user.email);
    this.emailId = loginData.user.email;
    this.userRole = loginData.user.roles;
    //this.getPageContent(this.publicationId, this.pageId, this.pageName);
  }

  getPrintSession() {
    this.addedparagraphList = [];
    this.paragraphIdsList = [];
    this.printqueueAddedList = [];
    let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
    if (printQueueData) {
      if (printQueueData != null && printQueueData.ParagraphIdsList != null) {
        this.addedparagraphList = printQueueData.ParagraphIdsList;
        this.paragraphIdsList = printQueueData.ParagraphIdsList;
        this.printqueueAddedList = printQueueData.printQueueAddedList;
      }
    }
  }

  OpenPCS() {
    var pageUrl = this.publicationId + '/' + this.pageId;
    let PCS = { url: pageUrl };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.router.navigateByUrl("/pendingcontentpageviewer");

  }

  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = ahref.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        if (ahref.toLowerCase().trim() == 'about the codification' && event?.currentTarget?.classList?.contains('generalNote')) {
          event.srcElement.setAttribute("href", "/" + 'about-us');

        } else {
          let otherSourceUrlParts = event.target.getAttribute('href').split("/");
          let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
          event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
        }
      }
    }
  }

  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }
  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 8; i >= 0; i--) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  openLinkById(event) {
    this.openLink.linkClicked(event);
  }

}
